import FireBaseTools from '../utils/firebase';
import {
    CHECKIN,
    GET_ALL_CHECKINS,
    DELETE_CHECKIN
} from './types';


export function checkin(details) {
    const request = FireBaseTools.checkin(details);

    return {
        type: CHECKIN,
        payload: request
    };
}

export function getAllCheckins() {
    const request = FireBaseTools.getAllCheckins();
    return {
        type: GET_ALL_CHECKINS,
        payload: request
    };
}

export function deleteCheckin(id) {
    const request = FireBaseTools.deleteCheckin(id);
    return {
        type: DELETE_CHECKIN,
        payload: request
    };
}


// WEBPACK FOOTER //
// ./src/app/actions/checkin.js